
define("json!rebrush/etc/breakpoints.json", function(){ return {
  	"mobile": 479,
  	"xs": 639,
	"sm": 1009,
	"md": 1229,
	"lg": 1439
};});

